<header>
  <div class="top-bar-wrapper container-xl">
    <button
      routerLink="/"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <img
        alt="Data explorer"
        id="profile-img"
        width="16"
        src="assets/data_explorer.svg"
      />
      Data explorer
    </button>
    <button
      routerLink="/size-of-prize"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <img
        alt="Size of prize"
        id="profile-img"
        width="16"
        src="assets/size_of_prize.svg"
      />
      Size of the prize
    </button>
  </div>
</header>
